<template>
  <v-container>
    <base-material-card
      color="primary"
      inline
      icon="mdi-account"
      class="ml-4 px-5 py-3"
      title="Informações Pessoais"
      elevation="0"
    >
      <v-row class="mx-2">
        <v-col md="6" cols="12" class="my-auto">
          <v-text-field
            color="primary"
            label="Nome"
            prepend-icon="mdi-card-account-details"
            v-model="nome"
            :disabled="tipoAutenticacao == 'cda'"
          />
        </v-col>
        <v-col md="6" cols="12" id="col-mpc" class="pt-1">
          <v-card-text class="pt-0">
            <label id="mpc">Perfis Associados</label>
            <v-chip-group show-arrows center-active>
              <v-chip
                color="#a2a8aa"
                text-color="white"
                v-for="(perfil, i) in perfis"
                :key="i"
              >
                <v-icon left>mdi-label</v-icon>
                {{ perfil }}
              </v-chip>
            </v-chip-group>
          </v-card-text>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col cols="12" sm="6">
          <v-select
            id="usuario-tipo"
            v-model="tipo"
            name="tipo"
            label="Tipo do usuário"
            :items="['COLABORADOR', 'TERCEIRO']"
            class="mb-0 pb-0"
            prepend-icon="mdi-tag"
            :disabled="tipoAutenticacao != 'database'"
          />
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col :cols="tipoAutenticacao == 'cda' ? '12' : '6'">
          <v-text-field
            color="primary"
            label="Email"
            prepend-icon="mdi-email"
            :value="email"
            disabled
          />
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            label="Cargo"
            prepend-icon="mdi-certificate"
            v-model="cargo"
            :disabled="tipoAutenticacao == 'cda'"
          />
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            label="Diretoria"
            prepend-icon="mdi-account-tie"
            v-model="diretoria"
            :disabled="tipoAutenticacao == 'cda'"
          />
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field
            color="primary"
            label="Area Executiva"
            prepend-icon="mdi-tie"
            v-model="area_executiva"
            :disabled="tipoAutenticacao == 'cda'"
          />
        </v-col>
      </v-row>
      <v-row v-if="tipoAutenticacao == 'database'" class="mx-auto">
        <v-col cols="12">
          <v-btn
            color="primary"
            min-width="100"
            style="float: right;"
            :disabled="!canSaveUserProfile"
            @click="saveUserProfile()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </base-material-card>

    <base-material-card
      v-if="tipoAutenticacao == 'database'"
      color="primary"
      inline
      icon="mdi-key"
      class="ml-4 px-5 pt-3 pb-3"
      title="Alterar senha"
      elevation="0"
    >
      <v-row class="mx-2">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="senhaAtual"
            :type="mostrarSenhaAtual ? 'text' : 'password'"
            label="Senha Atual"
            prepend-icon="mdi-lock"
            :append-icon="mostrarSenhaAtual ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="mostrarSenhaAtual = !mostrarSenhaAtual"
            :error-messages="senhaAtualErro"
            validate-on-blur
            :disabled="loading"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="senha"
            :type="mostrarSenha ? 'text' : 'password'"
            label="Senha"
            prepend-icon="mdi-lock-outline"
            :append-icon="mostrarSenha ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="mostrarSenha = !mostrarSenha"
            :error-messages="senhaErro"
            validate-on-blur
            :disabled="loading"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="senhaConfirmacao"
            :type="mostrarConfirmacaoSenha ? 'text' : 'password'"
            label="Confirmar senha"
            prepend-icon="mdi-lock-check-outline"
            :append-icon="mostrarConfirmacaoSenha ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="mostrarConfirmacaoSenha = !mostrarConfirmacaoSenha"
            :error-messages="senhaConfirmacaoErro"
            validate-on-blur
            :disabled="loading"
          />
        </v-col>
      </v-row>

      <v-row class="mx-auto">
        <v-col cols="12">
          <v-btn
            color="primary"
            min-width="100"
            style="float: right;"
            :disabled="!canSavePassword"
            @click="savePasswordProfile()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </base-material-card>

    <!-- <base-material-card
      color="primary"
      inline
      icon="mdi-office-building"
      class="ml-4 px-5 pt-3 pb-8"
      title="Lista de Empresas Liberadas"
      elevation="0"
    >
      <v-row class="mx-2">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="acessos"
            hide-default-footer
            disable-pagination
            no-results-text="Nenhum registro correspondente encontrado"
            class="borda"
          />
        </v-col>
      </v-row>
    </base-material-card> -->
  </v-container>
</template>

<script>
  import AuthService from "@/services/AuthService";
  import UsersService from "@/services/UsersService";

  export default {
    mounted() {
      this.getInfoUser();
      this.getTipoAutenticacao();
    },

    data: () => ({
      id: 0,
      nome: "",
      perfis: [],
      email: "",
      tipo: null,
      cargo: null,
      diretoria: null,
      area_executiva: null,
      senhaAtual: "",
      senha: "",
      senhaConfirmacao: "",
      mostrarSenha: false,
      mostrarSenhaAtual: false,
      senhaAtualErro: [],
      mostrarConfirmacaoSenha: false,
      tipoAutenticacao: null,
      loading: false,
      initialProfileData: {
        nome: "",
        cargo: "",
        diretoria: "",
        area_executiva: "",
        tipo: null,
      },
      acessos: [],
      headers: [
        { text: "Empresa", value: "empresa" },
        { text: "Perfil", value: "perfil" },
      ],
    }),

    computed: {
      hasProfileChanges() {
        return (
          this.nome !== this.initialProfileData.nome ||
          this.cargo !== this.initialProfileData.cargo ||
          this.diretoria !== this.initialProfileData.diretoria ||
          this.area_executiva !== this.initialProfileData.area_executiva ||
          this.tipo !== this.initialProfileData.tipo
        );
      },
      canSaveUserProfile() {
        return (
          this.tipoAutenticacao == "database" &&
          this.hasProfileChanges &&
          !this.loading
        );
      },
      senhaConfirmacaoErro() {
        if (!this.senhaConfirmacao) {
          return [];
        }

        return this.senha === this.senhaConfirmacao
          ? []
          : ["As senhas não coincidem."];
      },
      canSavePassword() {
        return (
          this.tipoAutenticacao == "database" &&
          !this.loading &&
          this.senhaAtual.length > 0 &&
          this.senha.length >= 8 &&
          this.senhaConfirmacao.length >= 8 &&
          this.senha === this.senhaConfirmacao
        );
      },
      senhaErro() {
        if (!this.senha) {
          return [];
        }

        return this.senha.length >= 8
          ? []
          : [`A nova senha deve ter pelo menos 8 caracteres.`];
      },
    },
    methods: {
      normalizeNullableField(value) {
        return value ?? "";
      },
      setInitialProfileData() {
        this.initialProfileData = {
          nome: this.normalizeNullableField(this.nome),
          cargo: this.normalizeNullableField(this.cargo),
          diretoria: this.normalizeNullableField(this.diretoria),
          area_executiva: this.normalizeNullableField(this.area_executiva),
          tipo: this.tipo,
        };
      },
      getInfoUser() {
        AuthService.getUserInfo().then((responseData) => {
          Object.assign(this, responseData);
          this.nome = this.normalizeNullableField(this.nome);
          this.cargo = this.normalizeNullableField(this.cargo);
          this.diretoria = this.normalizeNullableField(this.diretoria);
          this.area_executiva = this.normalizeNullableField(
            this.area_executiva,
          );
          this.setInitialProfileData();
        });
      },
      async getTipoAutenticacao() {
        this.tipoAutenticacao = await AuthService.getTipoAutenticacao();
      },
      saveUserProfile() {
        this.loading = true;

        const postData = {
          nome: this.nome,
          cargo: this.cargo,
          diretoria: this.diretoria,
          areaExecutiva: this.area_executiva,
          tipo: this.tipo,
        };

        UsersService.saveUserProfile(this.id, postData)
          .then(() => {
            this.setInitialProfileData();
            this.$toast.success("Usuário salvo com sucesso.", "", {
              position: "topRight",
            });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("Ocorreu um erro ao salvar o usuário.", "", {
              position: "topRight",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      savePasswordProfile() {
        this.loading = true;

        const postData = {
          senha_atual: this.senhaAtual,
          senha: this.senha,
          senha_confirmation: this.senhaConfirmacao,
        };

        UsersService.savePasswordProfile(this.id, postData)
          .then(() => {
            this.senha = "";
            this.senhaAtual = "";
            this.senhaConfirmacao = "";
            this.senhaAtualErro = [];
            this.mostrarSenha = false;
            this.mostrarConfirmacaoSenha = false;
            this.$toast.success("Senha salva com sucesso.", "", {
              position: "topRight",
            });
          })
          .catch((err) => {
            console.log("err:", err);
            console.log("err.response:", err?.response);
            console.log("err.response.data:", err?.response?.data);

            const mensagemErro =
              err?.response?.data?.error ||
              err?.data?.error ||
              err?.error ||
              (typeof err === "string" ? err : null) ||
              "Ocorreu um erro ao salvar a senha.";

            if (mensagemErro === "A senha atual está incorreta.") {
              this.senhaAtualErro = [mensagemErro];
            }

            this.$toast.error(mensagemErro, "", {
              position: "topRight",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style>
  #mpc {
    margin-left: 19px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.3);
    font-size: 12px;
  }

  #col-mpc .v-item-group {
    margin-left: 17px;
  }

  #col-mpc .v-slide-group--has-affixes {
    margin-left: -35px !important;
    width: 115% !important;
    max-width: 115% !important;
  }

  .borda {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
</style>
